<template>
  <div
    :id="this.id"
    @contextmenu.prevent="handler($event)"
    class="sitebuilder-element-container"
    element="MenuComponent"
    :class="{ 'full-width-element': this.internal_config.fullWidth }"
    :data-is-drip="this.internal_config.isDrip"
    :data-hide-desktop="!this.internal_config.showDesktop"
    :data-hide-mobile="!this.internal_config.showMobile"
    :config-properties="JSON.stringify(internal_config)"
    :style="style()"
    :dir="dir()"
    v-on:click="focusElement($event)"
  >
    <vue-draggable-resizable
      v-bind:w="parseInt(internal_config.width)"
      v-bind:h="parseInt(internal_config.height)"
      @resizing="onResize" ref="draggableResizable"
      :draggable="false"
    >
      <rotate :target="this.$refs.draggableResizable" :config="this.internal_config" />

      <sync-drag :target="this" />

      <options-element-bar ref="optionsBar" :elem="this" :name="'ct-component-MenuComponent'+(this.internal_config.isDrip?'Drip':'')">
        <img src="static/images/icons/engrenagem.svg"
          class="svg-icon normal-action"
          v-tooltip="{content:$t('ct-option-config-items', 'Items List'),  class: 'tooltip-custom'}"
          @click="openEdition"
        />
      </options-element-bar>

      <nav
        class="navbar navbar-expand-lg desktop-menu-element"
        v-bind:style="{
        'cursor':'pointer',
        'border-radius': radius,
        background: backgroundColor,
        border : border,
        'box-shadow': boxShadow,
      }"
      >
        <div class="collapse navbar-collapse" :class="[{'justify-content-center':this.internal_config.align === 'center'}, {'justify-content-end':this.internal_config.align === 'right'}]">
          <!-- <div class="navbar-brand py-2 mx-3" v-if="this.internal_config.brand.image && (this.internal_config.brand.position === 'left' || this.internal_config.brand.position === 'center')" href="#">
            <img :src="this.internal_config.brand.image" alt="logo" :style="{width: this.internal_config.brand.width}">
          </div> -->
          <ul :class="vertical ? 'navbar-nav flex-column' : 'navbar-nav' ">
            <li class="nav-item item-menu-sb" v-for="item in internal_config.itemList"
            :style="itemMenuStyle()"
            v-on:mouseenter="showDropDown(item.name, true)" 
            v-on:mouseleave="showDropDown(item.name, false)">
              <a
                :class="[item.children.length > 0 ? 'dropdown-toggle' : '', itemMenuPositionClass]"
                href="#"
                class="nav-link d-flex align-items-center"
                data-toggle="dropdown"
                @click="linkAction()"
                :id="item.children.length > 0 ? item.name:''"
                v-on:mouseover="mouseover"
                v-on:mouseleave="mouseleave"
                :style="[textStyle(), itemMenuDesktopStyle()]"
              >
                <span class="d-block text-truncate px-1">
                  <i
                  class="mdi"
                  v-if="item.icon.selected"
                  v-show="item.icon.position === 'left'"
                  :class="item.icon.selected"></i>
                  {{item.name}}
                  <i
                  class="mdi"
                  v-if="item.icon.selected"
                  v-show="item.icon.position === 'right'"
                  :class="item.icon.selected"></i>
                </span>
              </a>
              <div
                class="dropdown-menu"
                v-if="item.children.length > 0"
                :ref="item.name"
                v-bind:style="{background: backgroundColorSubItem}"
              >
                <a
                  class="dropdown-item"
                  v-for="child in item.children"
                  href="#"
                  @click="linkAction()"
                  v-on:mouseover="mouseSubOver"
                  v-on:mouseleave="mouseSubOut"
                  :style="[subTextStyle(), itemMenuDesktopStyle()]"
                ><span class="d-block px-1">
                  <i
                  class="mdi"
                  v-if="child.icon.selected"
                  v-show="child.icon.position === 'left'"
                  :class="child.icon.selected"></i>
                  {{child.name}}
                  <i
                  class="mdi"
                  v-if="child.icon.selected"
                  v-show="child.icon.position === 'right'"
                  :class="child.icon.selected"></i>
                  </span></a>
              </div>
            </li>
          </ul>
          <!-- <div class="lItemMenu"></div>
          <div class="bItemMenu"></div> -->
          <!-- <a class="navbar-brand mx-3" v-if="this.internal_config.brand.image && this.internal_config.brand.position === 'right'" href="#">
            <img :src="this.internal_config.brand.image" alt="logo" :style="{width: this.internal_config.brand.width}">
          </a> -->
        </div>
      </nav>

      <!-- Top Navigation Menu -->
      <div class="mobile-menu-element">
        <div class="topnav" v-bind:style="{background: backgroundColor,}">
          <div class="navbar-brand w-100 py-1 px-3 m-0 position-absolute" v-if="this.internal_config.brand.image"
               :class="[{'d-flex justify-content-start': this.internal_config.brand.position === 'left'}, {'d-flex justify-content-center': this.internal_config.brand.position === 'center'}, {'d-flex justify-content-end': this.internal_config.brand.position === 'right'}]"
               href="#">
            <img v-if="internal_config.brand.image && internal_config.brand.image !== 'none'" :src="this.internal_config.brand.image" alt="logo" :style="styleBrand()">
          </div>
          <a
            href="javascript:void(0);"
            class="icon"
            :class="menuIconPositionClass"
            :style="styleIconMenuBurgue"
            @click="myFunction"
            ref="burguerMenu"
          >
            <transition name="icon-change" v-if="internal_config.burguerMenu.showCloseIcon">
              <div
                class="mdi font-awesome-icon position-absolute"
                :key="internal_config.burguerMenu.displayCloseIcon"
                :class="internal_config.burguerMenu.displayCloseIcon ? 'mdi-close' : internal_config.burguerMenu.icon"
                style="font-size: 20px;"
              ></div>
            </transition>
            <div
              v-else
              class="mdi font-awesome-icon position-absolute"
              :class="internal_config.burguerMenu.icon"
              style="font-size: 20px;"
            ></div>
          </a>
        </div>
        <div id="myLinks" ref="burguer">
          <div v-for="item in this.internal_config.itemList">
            <itemMenuMobile :item="item" :text-style="textStyle()" :sub-text-style="subTextStyle()"/>
          </div>
        </div>
      </div>

      <resources ref="resourcesData"></resources>
    </vue-draggable-resizable>
  </div>
</template>

<script>
import Data from './Model';
import Resources from './Resources.vue';
import OptionsElementBar from '../OptionsElementBar';
import ItemMenuMobile from './ItemMenuMobile';
import ConfigModals from './ConfigModals';
import {SweetModal} from 'sweet-modal-vue';

export default {
  name: 'MenuComponent',
  props: ['config', 'id', 'preview'],
  components: {
    ItemMenuMobile,
    OptionsElementBar,
    Data,
    Resources,
    ConfigModals,
    SweetModal
  },
  computed: {
    vertical() {
      return this.internal_config.vertical;
    },
    border() {
      return this.internal_config.border;
    },
    boxShadow() {
      return this.internal_config.boxShadow;
    },
    radius() {
      return this.internal_config.borderRadius;
    },
    backgroundColor() {
      return this.internal_config.backgroundColor;
    },
    backgroundColorItem() {
      return this.internal_config.btnStyle.backgroundColor;
    },
    backgroundColorSubItem() {
      return this.internal_config.subStyle.backgroundColor;
    },
    menuIconPositionClass() {
      return {
        leftIconPosition: this.internal_config.burguerMenu.position === 'left',
        rightIconPosition:
          this.internal_config.burguerMenu.position === 'right',
        centerIconPosition:
          this.internal_config.burguerMenu.position === 'center'
      };
    },
    itemMenuPositionClass() {
      return {
        'justify-content-end': this.internal_config.btnStyle.align === 'right',
        'justify-content-start': this.internal_config.btnStyle.align === 'left',
        'justify-content-center': this.internal_config.btnStyle.align === 'center'
      };
    },
    styleIconMenuBurgue() {
      return `color: ${this.internal_config.burguerMenu.color};
      background: ${this.internal_config.burguerMenu.backgroundColor};
      width: 3.6em;
      height: 3.4em;`;
    }
  },
  data() {
    return Data.data();
  },
  watch: {
    'internal_config': {
      deep: true,
      handler(value) {
        this.$eventHub.setValueElementConfig(this.id, value);
        this.$eventPointer.log(this.id, value);
      }
    }
  },

  methods: {
    animation() {
      return false;
    },
    myFunction() {
      let x = this.$refs.burguer;
      let selectedEffect = this.internal_config.menuMobileEffect;
      let options = {};

      if (x.style.display === 'block') {
        this.internal_config.burguerMenu.displayCloseIcon = false;
      } else {
        this.internal_config.burguerMenu.displayCloseIcon = true;
      }

      if (selectedEffect === 'size') {
        options = { to: { width: 0, height: 0 } };
      }

      if (selectedEffect) {
        $(x).toggle(selectedEffect, options, 500);
      } else {
        $(x).toggle();
      }
    },

    saveAll(config) {
      // comentei esse trecho pois tava dando ruim na configuração dos items do menu, o itemEdition e subitemEdition são utilizados
      // if (this.internal_config.itemEdition) {
      //   delete this.internal_config.itemEdition
      // }
      // if (this.internal_config.subitemEdition) {
      //   delete this.internal_config.subitemEdition
      // }

      this.internal_config = Object.assign({}, this.internal_config, config);
    },
    openEdition() {
      this.$root.$emit('openMenuModal', this.internal_config, 'fields', this.saveAll);
    },

    mouseover(e) {
      let element = e.toElement;

      if (element.classList.contains('nav-link')) {
        element.style.backgroundColor = this.internal_config.btnStyle.backgroundColorHover;
        element.style.color = this.internal_config.btnStyle.colorHover;
      }
    },

    mouseleave(e) {
      let element = e.fromElement;

      if (element.classList.contains('nav-link')) {
        element.style.backgroundColor = this.internal_config.btnStyle.backgroundColor;
        element.style.color = this.internal_config.btnStyle.color;
      }
    },
    mouseSubOver(e) {
      let element = e.toElement;

      if (element.classList.contains('dropdown-item')) {
        element.style.backgroundColor = this.internal_config.subStyle.backgroundColorHover;
        element.style.color = this.internal_config.subStyle.colorHover;
      }
    },

    mouseSubOut(e) {
      let element = e.fromElement;

      if (element.classList.contains('dropdown-item')) {
        element.style.backgroundColor = this.internal_config.subStyle.backgroundColor;
        element.style.color = this.internal_config.subStyle.color;
      }
    },

    showDropDown(id, show) {
      $(".dropdown-menu").hide();

      if (typeof this.$refs[id] !== 'undefined') {
        $(this.$refs[id][0]).css('max-height', window.innerHeight);
        this.$refs[id][0].style.display =
          this.$refs[id][0].style.display === 'none' ? 'block' : 'none';
      }

      if (typeof this.$refs[id] !== 'undefined') {
        this.$refs[id][0].style.display = show ? 'block' : 'none';
      }
    },
    // linkElement: function () {
    // this.$root.$emit('linkComponentShow', this);
    // },

    linkAction(){
      if (this.$props.preview)
        this.$snotify.warning(this.$t('ct-only-works-on-publication'))
    },

    onResize: function(x, y, width, height) {
      this.internal_config.width = width + 'px';
      this.internal_config.height = height + 'px';

      this.$refs.resourcesData.setValuesData(this);
    },

    focusElement(e) {
      this.$root.$emit("focusElement", this);
      this.$root.$emit('handlerElement', this);


      e.stopPropagation();
      e.preventDefault();
    },
    showResources() {
      return this.$refs.resourcesData.getValuesData();
    },

    deleteImage() {
      this.$emit('delete', {});
    },
    edit(e) {
      e.preventDefault();
      this.internal_config.src = prompt('src', this.internal_config.src);
    },
    buildIcon: function() {
      $(this.$el)
        .find('i')
        .detach();

      if (this.internal_config.icon !== '') {
        if (this.internal_config.iconPosition === 'left') {
          $('<i>')
            .addClass('mdi ' + this.internal_config.icon)
            .prependTo(
              $(this.$el)
                .find('.sb-text')
                .get(0)
            );
        }
        if (this.internal_config.iconPosition === 'right') {
          $('<i>')
            .addClass('mdi ' + this.internal_config.icon)
            .appendTo(
              $(this.$el)
                .find('.sb-text')
                .get(0)
            );
        }
      }
    },
    build() {
      this.buildIcon();
    },
    itemMenuStyle() {
      return {
        marginLeft: parseInt(this.internal_config.spacing)/2 + 'px',
        marginRight: parseInt(this.internal_config.spacing)/2 + 'px',
        borderRadius: this.internal_config.itemMenuBorderRadius,
        background: this.internal_config.btnStyle.backgroundColor
      };
    },
    textStyle() {
      return {
        fontFamily: this.internal_config.btnStyle.family,
        fontSize: this.internal_config.btnStyle.size,
        textAlign: this.internal_config.btnStyle.align,
        fontWeight: this.internal_config.btnStyle.weight,
        fontStyle: this.internal_config.btnStyle.style,
        color: this.internal_config.btnStyle.color,
        '--menu-item-color--hover': this.internal_config.btnStyle.colorHover,
        border: this.internal_config.itemMenuBorder,
        boxShadow: this.internal_config.itemMenuBoxShadow,
        '--menu-item-background': this.internal_config.btnStyle.backgroundColor,
        '--menu-item-background--hover': this.internal_config.btnStyle.backgroundColorHover,
        '--menu-item-background-active': this.internal_config.btnStyle.backgroundColorActive
      };
    },
    subTextStyle() {
      return {
        fontFamily: this.internal_config.subStyle.family,
        fontSize: this.internal_config.subStyle.size,
        textAlign: this.internal_config.subStyle.align,
        fontWeight: this.internal_config.subStyle.weight,
        fontStyle: this.internal_config.subStyle.style,
        color: this.internal_config.subStyle.color,
        border: this.internal_config.itemMenuSubBorder,
        display: 'grid',
        '--sub-item-background': this.internal_config.subStyle.backgroundColor,
        '--sub-item-background--hover': this.internal_config.subStyle.backgroundColorHover
      };
    },
    styleBrand(){
      return {
        maxWidth: parseInt(this.internal_config.brand.width) + 'px',
        width: parseInt(this.internal_config.brand.width) + 'px',
        maxHeight: '50px',
        padding: 0
      };
    },
    itemMenuDesktopStyle() {
      return {
        paddingLeft: parseInt(this.internal_config.itemMenuWidth) /10 + 'px',
        paddingRight: parseInt(this.internal_config.itemMenuWidth) /10 + 'px',
        height: parseInt(this.internal_config.itemMenuHeight) + 'px',
        borderRadius: this.internal_config.itemMenuBorderRadius,
        paddingTop: 0,
        paddingBottom: 0
      };
    },
    dir() {
      let defaultLocale = (window.getCookie('languageEditorUser') != null) ? window.getCookie('languageEditorUser') : 'en_US';
      if (
        defaultLocale === 'he_IL' ||
        defaultLocale === 'ja_JP' ||
        defaultLocale === 'ar_AR'
      ) {
        return 'rtl';
      } else return false;
    },
    style() {
      return `left:  ${this.internal_config.left};
                    z-index: ${this.internal_config.zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
              padding-top: ${this.internal_config.paddingTop};
              padding-left: ${this.internal_config.paddingLeft};
              padding-right: ${this.internal_config.paddingRight};
              padding-bottom: ${this.internal_config.paddingBottom};
              top: ${this.internal_config.top}`;
    },
    styleResize() {
      return `{width: ${this.internal_config.width}, height:  ${this.internal_config.height}}`;
    },
    handler: function(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this, true);
      e.stopPropagation();
      e.preventDefault();
    },
    animateField() {
      this.internal_config.fieldAnimated = true;
    },
    changePosition(index, newIndex) {
      if (newIndex >= this.internal_config.itemList.length || newIndex < 0) {
        return;
      }

      this.animateField();
      this.internal_config.itemList.splice(
        newIndex,
        0,
        this.internal_config.itemList.splice(index, 1)[0]
      );
    },
    changePositionSubmenu(index, newIndex) {
      if (
        newIndex >= this.internal_config.itemList.children.length ||
        newIndex < 0
      ) {
        return;
      }

      this.animateField();
      this.internal_config.itemList.children.splice(
        newIndex,
        0,
        this.internal_config.itemList.children.splice(index, 1)[0]
      );
    }
  },
  mounted() {
    this.internal_config = window.mergeRecursive(
      this.props,
      this.$props.config
    );

    this.build();

    if (['undefined', 'string'].includes(typeof this.internal_config.burguerMenu)) {
      this.internal_config.burguerMenu = {
        position: 'right',
        icon: 'mdi-menu',
        showCloseIcon: true,
        displayCloseIcon: false,
        backgroundColor: '#000',
        color: '#fff'
      };
    }

    this.internal_config.burguerMenu.displayCloseIcon = false;

    if (this.$props.preview) {
      this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');

      this.$el.classList.add('preview');
    }

    let objIds = [];
    $('[id]').each(function() {
      var ids = $('[id="' + this.id + '"]');
      if (ids.length > 1 && ids[0] == this && parseInt(this.id)) {
        objIds.push(this.id);
      }
    });

    if (objIds.includes(this.id)) {
      this.id = Date.now() + parseInt(Math.random() * 10000);
    }

    this.$root.$on('setConfigElement', (id, obj) => {
      if(this.id == id){
        this.config = obj;
        this.internal_config = obj;
      }
    });
    this.$root.$on('setAsDrip', (id) => {
      if(this.id == id){
        this.config.isDrip = true;
        this.internal_config.isDrip = true;
      }
    });

    if (typeof this.internal_config.burguerMenu === 'string') {
      this.internal_config.burguerMenu = {
        position: this.internal_config.burguerMenu,
        icon: 'mdi-menu',
        backgroundColor: '#000',
        color: '#fff'
      };
    }

    this.$refs.resourcesData.setValuesData(this);
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.menu-sb-component,
.vdr {
  width: auto !important;
  height: auto !important;

  .nav-link {
    background: var(--menu-item-background);

    //Hover for menu item
    &:hover {
      background: var(--menu-item-background--hover);
    }

    //Dropdown active
    &.dropdown-toggle.active {
      background: var(--menu-item-background-active);
    }
  }

  .dropdown-item {
    background: var(--sub-item-background);

    //Hover for sub item
    &:hover {
      background: var(--sub-item-background--hover);
    }
  }

  .navbar {
    padding: 0px;
    height: auto;
    white-space: nowrap;

    /*.item-menu-sb:first-of-type {*/
    /*  margin-left: 0 !important;*/
    /*}*/
  }

  .navbar-nav .dropdown-menu {
    padding: 0;
    margin: 0;
    min-width: 0px;
    border-radius: 0;
    overflow-y: auto;
  }

  .topnav {
    overflow: hidden;
    background-color: #333;
    position: relative;
    min-height: 57px;
    text-align: center;
    cursor: pointer;

    .burguer-sub-item {
      padding-left: 15px;
    }

    a {
      color: white;
      padding: 14px 16px;
      text-decoration: none;
      font-size: 17px;
      display: block;

      &.icon {
        background: black;
        display: block;
        position: absolute;
        top: 0;
      }

      &:hover {
        background-color: #ddd;
        color: black;
      }
    }
  }

  #myLinks {
    display: none;
  }

  .lItemMenu {
    width: 10px;
    background-color: rgb(2, 148, 255);
    position: relative;
    transform: skewY(45deg);
    top: 5px;
  }

  .bItemMenu {
    height: 10px;
    width: 120px;
    background-color: rgb(2, 148, 255);
    transform: skew(45deg) translateX(5px);
    position: relative;
    bottom: 4px;
  }

  .leftIconPosition {
    left: 0;
  }

  .rightIconPosition {
    right: 0;
  }

  .centerIconPosition {
    right: calc(50% - 30px);
  }

  .active {
    // background-color: #4caf50;
    color: white;
  }

  .icon-change-enter, .icon-change-leave-to {
    transform: rotate(180deg) scale(0.5);
    opacity: 0;
  }

  .icon-change-enter-to, .icon-change-leave {
    transform: rotate(0deg) scale(1);
    opacity: 1;
  }

  .icon-change-enter-active, .icon-change-leave-active {
    transition: opacity 0.3s, transform 0.3s;
  }
}

@media (max-width: 800px) {
  .desktop-menu-element {
    display: none;
  }

  .mobile-menu-element {
    display: block;
  }
}

@media (min-width: 801px) {
  .desktop-menu-element {
    display: block;
  }

  .mobile-menu-element {
    display: none;
  }
}
</style>
<style lang="scss">
.nav-item {
  position: relative;
}

.navbar-nav.flex-column .dropdown-menu {
  left: 100%;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Menu/Menu.vue